// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3qqAX","header":"ReportDetails_header__3bmJg","title":"ReportDetails_title__S3VPS","left":"ReportDetails_left__1USHn"};